module.exports = __webpack_public_path__ + "img/photo-0113.6006d864.jpg";